import {pointCallback} from "@/api/CommonApi";

/**
 * 增加积分的mixin
 * @author wwy
 */
export default {
    data(){
        return{
            addPointSetTimeout:null,
            addPointTime:1000 * 65,
        }
    },
    watch:{
        id(){
            this.mountedAddPointSetTimeout()
        },
        itemId(val){
            if(!val) return;
            this.mountedAddPointSetTimeout();
        }
    },
    /** 挂载时 */
    mounted(){
        this.mountedAddPointSetTimeout()
    },
    /** 卸载时 */
    unmounted() {
        if(this.addPointSetTimeout){
            clearTimeout(this.addPointSetTimeout)
        }
    },
    methods:{
        mountedAddPointSetTimeout(){
            // 如果计时器已装载 -> 卸载重装
            if(this.addPointSetTimeout){
                clearTimeout(this.addPointSetTimeout)
            }
            if(!this.id){
                console.warn(`unknown id`)
                return
            }
            this.addPointSetTimeout = setTimeout(() => {// 设置计时器回调函数
                pointCallback(this.id,this.itemId || null).then(res => {
                    if(res.code === 200 && res.success) {
                        console.log('积分+1')
                    }
                })
            },this.addPointTime)
        }
    }
}
